/*document.addEventListener('DOMContentLoaded', function() {
  console.log("MANINSIDE!");
  const popup = document.getElementById('custom-popup');
  const closeBtn = document.querySelector('.close-btn');
  
  // Controlla se il popup è stato chiuso nelle ultime 24 ore
  const popupClosed = localStorage.getItem('popupClosed');
  const now = new Date().getTime();

  if (!popupClosed || now - popupClosed > 86400000) { // 86400000 ms = 24 ore
    setTimeout(() => {
      popup.style.display = 'flex';
    }, 5000);
  }

  // Funzione di chiusura
  function closePopup() {
    popup.style.display = 'none';
    localStorage.setItem('popupClosed', new Date().getTime());
  }

  // Chiudi con bottone
  closeBtn.addEventListener('click', closePopup);

  // Chiudi con ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.style.display === 'flex') {
      closePopup();
    }
  });

  // Chiudi cliccando fuori dal contenuto
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      closePopup();
    }
  });
});*/
console.log("START!");